import { custom, deserialize, serializable } from 'serializr';
import { Deserializable } from '@models/deserializable';

export class JiraFieldAllowedValue implements Deserializable {
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable
  public value: string;
  @serializable
  public iconUrl: URL;
  @serializable
  public description: string;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public avatarUrls: Map<string, URL>;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(JiraFieldAllowedValue, input));
  }
}
